type DomainParts = [string, string];

let overrideRootDomain: string | undefined;

const getTldAndEnvironment = (): DomainParts => {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return process.env.MOBILE_ENV === 'development' ? ['com', 'demo-owl'] : ['io', 'import'];
  }

  const hostname =
    (typeof window !== 'undefined' && window.location ? window.location.hostname : undefined) ??
    (typeof globalThis !== 'undefined' && 'location' in globalThis
      ? (globalThis as { location?: { hostname?: string } }).location?.hostname
      : undefined);

  if (hostname) {
    const parts = hostname.split('.').reverse();
    if (parts.length >= 2 && parts[0] && parts[1]) {
      return [parts[0], parts[1]];
    }
  }

  return ['io', 'import'];
};

const resolveRootDomain = (): string => {
  const [tld, environment] = getTldAndEnvironment();
  return overrideRootDomain || process.env.ENDPOINTS_ROOT_DOMAIN || `${environment}.${tld}`;
};

export const endpoints = {
  set endpointsRootDomain(value: string | undefined) {
    overrideRootDomain = value;
  },

  get endpointsRootDomain(): string | undefined {
    return overrideRootDomain;
  },

  get tldAndEnvironment(): DomainParts {
    return getTldAndEnvironment();
  },

  get rootDomain(): string {
    return resolveRootDomain();
  },

  get appBaseUrl(): string {
    return process.env.ENDPOINTS_APP_BASE_URL || `https://app.${this.rootDomain}`;
  },

  get workbenchApiBaseUrl(): string {
    return process.env.ENDPOINTS_WORKBENCH_API_BASE_URL || `https://workbench.${this.rootDomain}/api`;
  },
};

export default endpoints;
